import LangEnum from '../../../../lang/LangEnum';
import {
  TargetBreakdownType,
  TargetCriterionType,
  TargetParameterType,
  TargetPeriodType,
  TargetUnit,
} from '../../../../services/modules/target/target.types';
import { CompactAvailability } from '../../../products/ProductTypes';

export const TARGET_UNIT_LABEL: Record<TargetUnit, LangEnum> = {
  [TargetUnit.GROSS_MONEY]: LangEnum.GLOBAL_GROSS_VALUE,
  [TargetUnit.NET_MONEY]: LangEnum.GLOBAL_NET_VALUE,
  [TargetUnit.QUANTITY]: LangEnum.GLOBAL_PIECES,
};

export const TARGET_BREAKDOWN_TYPE_LABEL: Record<TargetBreakdownType, LangEnum> = {
  [TargetBreakdownType.CLASSIFICATION_TECEO]: LangEnum.TARGET_BREAKDOWN_TYPE_CLASSIFICATION_TECEO,
  [TargetBreakdownType.BRAND_CATEGORY]: LangEnum.TARGET_BREAKDOWN_TYPE_BRAND_CATEGORY,
  [TargetBreakdownType.BRAND_SUB_CATEGORY]: LangEnum.TARGET_BREAKDOWN_TYPE_BRAND_SUB_CATEGORY,
  [TargetBreakdownType.BRAND_CLASSIFICATION]: LangEnum.TARGET_BREAKDOWN_TYPE_BRAND_CLASSIFICATION,
  [TargetBreakdownType.DELIVERY_WINDOW]: LangEnum.GLOBAL_DELIVERY_WINDOW,
};

export const TARGET_CRITERION_TYPE_LABEL: Record<TargetCriterionType, LangEnum> = {
  [TargetCriterionType.AVAILABILITY]: LangEnum.GLOBAL_AVAILABILITY,
  [TargetCriterionType.DELIVERY_WINDOW]: LangEnum.GLOBAL_DELIVERY_WINDOW,
  [TargetCriterionType.PRODUCT_CLASSIFICATION]:
    LangEnum.TARGET_CRITERION_TYPE_PRODUCT_CLASSIFICATION,
  [TargetCriterionType.CUSTOMER_CLASSIFICATION]:
    LangEnum.TARGET_CRITERION_TYPE_CUSTOMER_CLASSIFICATION,
};

export const TARGET_PARAMETER_TYPE_LABEL: Record<TargetParameterType, LangEnum> = {
  [TargetParameterType.PERIOD]: LangEnum.TARGET_PARAMETER_TYPE_PERIOD,
  [TargetParameterType.GROWTH]: LangEnum.TARGET_PARAMETER_TYPE_GROWTH,
  [TargetParameterType.TARGET_COVERAGE]: LangEnum.TARGET_PARAMETER_TYPE_TARGET_COVERAGE,
};

export const TARGET_AVAILABILITY_LABEL: Record<CompactAvailability, LangEnum> = {
  [CompactAvailability.PRE_ORDER]: LangEnum.GLOBAL_PRE_ORDER,
  [CompactAvailability.READY_FOR_DELIVERY]: LangEnum.GLOBAL_READY_FOR_DELIVERY,
};

export const TARGET_PERIOD_TYPE_LABEL: Record<TargetPeriodType, LangEnum> = {
  [TargetPeriodType.DATE_RANGE]: LangEnum.TARGET_PERIOD_TYPE_DATE_RANGE,
  [TargetPeriodType.ORDER_COLLECTION]: LangEnum.GLOBAL_ORDER_COLLECTION,
  [TargetPeriodType.PRODUCT_COLLECTION]: LangEnum.GLOBAL_PRODUCT_COLLECTION,
};
